import styled from 'styled-components'

export const HomePageContainer = styled.div`
  padding: 20px 80px;

  @media only screen and (max-width: 576px) {
    padding: 20px 60px;
  }
`
